import { pharmacyClient } from "@/connect";
import { ItemSalesVelocityReportResponse } from "@/gen/reports/item_sales_velocity_report_pb";

export const getItemSalesVelocity = async (
  page: number,
  pageSize: number
): Promise<ItemSalesVelocityReportResponse> => {
  return await pharmacyClient.itemSalesVelocityReport({
    pageNumber: page,
    pageSize: pageSize,
  });
};